import React from 'react';
import PropTypes from 'prop-types';
import PureComponent from 'lib/purecomponent';
import {startCase} from 'lodash';
import {Subject as SubjectModelV2} from 'resources/GeneratedModels/Subject/SubjectModel.v2';

export default class SubjectLineItem extends PureComponent {
  static propTypes = {
    subject: PropTypes.instanceOf(SubjectModelV2).isRequired,
    guideType: PropTypes.string
  };

  render() {
    const {guideType, subject} = this.props;
    return (
      <li className='guide-table-row guide-table-row--subject'>
        <div className='guide-table-cell-indent-0 guide-table-row-cell guide-table-row-cell--bold guide-table-row-cell--auto'>
          {subject.getName()} {guideType && ` - ${startCase(guideType)}`}
        </div>
      </li>
    );
  }
}
